export default {
  isViewType: null,
  isHandDvice: null,
  viewportWidth: null,
  viewportHeight: null,
};
